var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Order',{attrs:{"orderId":_vm.orderId}})}
var staticRenderFns = []

export { render, staticRenderFns }